import { CheckedComponentInformation } from '@west-australian-newspapers/json-react-layouts'
import { Topic } from '@news-mono/web-common'
import { layout } from '../../../../App.routing'
import { getAflCurationSierraComponent } from '../afl-route-component-layouts'

const bannerDesktopX1 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Desktop-@1x.jpg')
const bannerDesktopX2 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Desktop-@2x.jpg')
const bannerMobileX1 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Mobile-@1x.jpg')
const bannerMobileX2 = require<string>('./assets/2026_WA-Footy-Lives-Here-Banner-Mobile-@2x.jpg')
const socialImage = require('./assets/2026_WA-Footy-Lives-Here-Social.jpg')

export const getFootyLivesHereSocialImageMeta = (topic: Topic) => [
    {
        property: 'og:image',
        content: socialImage,
    },
    {
        property: 'og:image:width',
        content: '1920',
    },
    {
        property: 'og:image:height',
        content: '1080',
    },
    {
        name: 'twitter:image',
        content: socialImage,
    },
    {
        property: 'og:description',
        content: topic.seoDescription ?? `The Latest in ${topic.title}`,
    },
    {
        property: 'twitter:description',
        content: topic.seoDescription ?? `The Latest in ${topic.title}`,
    },
]

export const getFootyLivesHereHeader = (
    topic: Topic,
): CheckedComponentInformation[] => {
    return [
        layout.component({
            type: 'image-banner',
            props: {
                defaultSrc: bannerDesktopX2,
                verticalGutters: ['unset', 'md'],
                altText: topic.seoTitle,
                disableHeader: true,
                sources: [
                    {
                        breakpoint: 'sm',
                        src: [
                            {
                                src: bannerDesktopX1,
                                density: '1x',
                            },
                            {
                                src: bannerDesktopX2,
                                density: '2x',
                            },
                        ],
                    },
                    {
                        src: [
                            {
                                src: bannerMobileX1,
                                density: '1x',
                            },
                            {
                                src: bannerMobileX2,
                                density: '2x',
                            },
                        ],
                    },
                ],
            },
        }),
        layout.nestedComposition({
            type: 'janus',
            props: {
                layoutRatio: '3:1',
                stretchColumns: true,
                verticalSpacing: 'xl',
            },
            contentAreas: {
                left: [getAflCurationSierraComponent()],
                right: [
                    layout.component({
                        type: 'footy-lives-here-promo-card',
                        props: {},
                    }),
                ],
            },
        }),
    ]
}
